$("span[popupbutton]").click(function () {
    var id = $(this).attr("popupButton");
    if ($('.popup--content[popupcontent="' + id + '"]').is(":visible")) {
        $('.popup--content[popupcontent="' + id + '"]').fadeOut();
        $(this).removeClass("active");
    } else {
        $('.popup--content[popupcontent="' + id + '"]').fadeIn();
        $('.popup--content:not([popupcontent="' + id + '"])').fadeOut();
        $(this).addClass("active");
    }
    //   $('.team--popup--wrapper[popupcontent="' + id + '"]').addClass("team--popup--wrapper--visible");
    //   $('.team--popup--wrapper[popupcontent="' + id + '"]').css("overflow", "visible");

    $(document).mouseup(function (e) {
        var container = $(".popup--content");
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            $(".popup--content").fadeOut();
            $("span[popupbutton]").removeClass("active");
        }
    });
});
